// 调课申请
import exchangeK from "@/components/newPages/teacher/exchangeK/index";
import exchangeKItem from "@/components/newPages/teacher/exchangeK/item";
import exchangeKHistoryList from "@/components/newPages/teacher/exchangeK/historyList";
// 个人调课 10008
import personalTableIndex from "@/components/newPages/teacher/exchangeK/personalTable/index";
import personalTableApply from "@/components/newPages/teacher/exchangeK/personalTable/apply";
// 工作量查询
import workNum from "@/components/newPages/teacher/workNum/index";
import workNum_shzdx from "@/components/newPages/teacher/workNum/index_shzdx";
// 教室借用
import roomBorrow from "@/components/newPages/teacher/roomBorrow/index";
import borrowList from "@/components/newPages/teacher/roomBorrow/borrowList";
import borrowBar from "@/components/newPages/teacher/roomBorrow/borrowBar";
import moreResearch from "@/components/newPages/teacher/roomBorrow/moreResearch";
import roomBorrowHistoryList from "@/components/newPages/teacher/roomBorrow/historyList";
import historyList_10534 from "@/components/newPages/teacher/roomBorrow/historyList_10534";
// 教室借用申请 10008
import brrow10008Index from "@/components/newPages/teacher/roomBorrow/roomBorrow_10008/index";
import brrow10008Apply from "@/components/newPages/teacher/roomBorrow/roomBorrow_10008/apply";

// 学生信息查询 10008
import informationService from "@/components/newPages/teacher/informationService/index";
import studentStatus from "@/components/newPages/teacher/informationService/studentStatus";
import change from "@/components/newPages/teacher/informationService/change";
import achievement from "@/components/newPages/teacher/informationService/achievement";
import informationInquiryTimetable from "@/components/newPages/teacher/informationService/informationInquiryTimetable";
import innovationCredits from "@/components/newPages/teacher/informationService/innovationCredits";
import examination from "@/components/newPages/teacher/informationService/examination";

// 成绩管理
import updateIndex from "@/components/newPages/teacher/grade/update/index";
import gradeUpdate from "@/components/newPages/teacher/grade/update/gradeUpdate";
import searchIndex from "@/components/newPages/teacher/grade/search/index";
import searchIndex_13383 from "@/components/newPages/teacher/grade/search/index_13383";
import cjsearchIndex from "@/components/newPages/teacher/grade/search/search";
import cjsearchGrade from "@/components/newPages/teacher/grade/search/searchGrade";
import gradeItem from "@/components/newPages/teacher/grade/search/gradeItem";
// 培养方案
import pyfazgIndex from "@/components/newPages/teacher/train/pyfazgIndex";
import commonIndex from "@/components/newPages/teacher/train/commonIndex";
import teachingProcess from "@/components/newPages/teacher/train/teachingProcess";
import teachingPlan from "@/components/newPages/teacher/train/teachingPlan";
// 审核
import pass from "@/components/newPages/teacher/pass/index";
import passBar from "@/components/newPages/teacher/pass/passBar";
import passIndex from "@/components/newPages/teacher/pass/passIndex";
import passList from "@/components/newPages/teacher/pass/passList";
import unDeal from "@/components/newPages/teacher/pass/unDeal";
import deal from "@/components/newPages/teacher/pass/deal";
// 班级课表
import classTable from "@/components/newPages/teacher/classTable/index";
// 全校课表
import indexqx from "@/components/newPages/teacher/classTable/indexqx";
// 课程成绩单
import indexkccjd from "@/components/newPages/teacher/classTable/indexkccjd";
// 课程测试
import classTest from "@/components/newPages/teacher/yunClass/index";
// 学生名单查询
import studentInfoIndex from "@/components/newPages/teacher/studentInfo/index";
import studentInfoInfo from "@/components/newPages/teacher/studentInfo/info";
// 教学咨询
import jxzxIndex from "@/components/newPages/teacher/jxzx/index";
import jxzxItem from "@/components/newPages/teacher/jxzx/item";
// 学生评价统计
import evaluateSumIndex from "@/components/newPages/teacher/evaluateSum/index";
import evaluateSumItem from "@/components/newPages/teacher/evaluateSum/item";
import evaluationResultsIndex from "@/components/newPages/teacher/evaluationResults/index";
// 实习考勤
import practiceKQInedx from "@/components/newPages/teacher/practiceKQ/index";
import practiceKQItem from "@/components/newPages/teacher/practiceKQ/item";
// 任务发布
import taskAddIndex from "@/components/newPages/teacher/taskAdd/index";
import taskAddItem from "@/components/newPages/teacher/taskAdd/item";
import studentDetail from "@/components/newPages/teacher/taskAdd/studentDetail";
import evaluateItem from "@/components/newPages/teacher/taskAdd/evaluateItem";
import taskAdd from "@/components/newPages/teacher/taskAdd/taskAdd";
// 免听审核
import freePassIndex from "@/components/newPages/teacher/freePass/index";
import freePassList from "@/components/newPages/teacher/freePass/list";
import freePassPass from "@/components/newPages/teacher/freePass/pass";
// 劳动任务审核
import workTaskPassIndex from "@/components/newPages/teacher/workTaskPass/index";
import workTaskPassList from "@/components/newPages/teacher/workTaskPass/list";
// 数据确认审核
import sksjqrshIndex from "@/components/newPages/teacher/sksjqrsh/index";
import sksjqrshDetail from "@/components/newPages/teacher/sksjqrsh/detail";
// 授课数据申请审核
import sksjsqshIndex from "@/components/newPages/teacher/sksjsqsh/index";
import sksjsqshDetail from "@/components/newPages/teacher/sksjsqsh/detail";
// 北京劳动保障职业学院考试 安排查询
import ksapcxIndex from "@/components/newPages/teacher/ksapcx/index";
import ksapcxDetail from "@/components/newPages/teacher/ksapcx/detail";
// 调课审核
import tksh from "@/components/newPages/teacher/tksh/index";
import tkshUnpass from "@/components/newPages/teacher/tksh/unpass";
import tkshPass from "@/components/newPages/teacher/tksh/pass";
import tkshDetail from "@/components/newPages/teacher/tksh/tkshDetail";
import tkshPlsh from "@/components/newPages/teacher/tksh/plsh";
import tkshCommompass from "@/components/newPages/teacher/tksh/tkshCommompass";
import HomeMore_10013 from "@/components/newPages/Home/HomeMore_10013";

// 选课名单查看
import jxapgl from "@/components/newPages/teacher/xkmdck/jxapgl";
import xkxslb from "@/components/newPages/teacher/xkmdck/xkxslb";
// 选课状态查看
import xkztck from "@/components/newPages/teacher/xkztck/index";
// 学籍异动审核
import xjydsh from "@/components/newPages/teacher/xjydsh/index";
import xjydshDetail from "@/components/newPages/teacher/xjydsh/detail";
import xjydshSh from "@/components/newPages/teacher/xjydsh/sh";
import ksxxcx from "@/components/newPages/student/ksxxcx/index"
const newTeacherRoute = [
  // 学籍异动审核
  {
    path: "/xjydsh/index",
    name: "xjydsh",
    component: xjydsh,
    meta: {
      title: "学籍异动审核"
    }
  },
  {
    path: "/xjydsh/detail",
    name: "xjydshDetail",
    component: xjydshDetail,
    meta: {
      title: "异动详情"
    }
  },
  {
    path: "/xjydsh/sh",
    name: "xjydshSh",
    component: xjydshSh,
    meta: {
      title: "学籍异动审核"
    }
  },
  // 选课状态查看
  {
    path: "/xkztck/index",
    name: "xkztck",
    component: xkztck,
    meta: {
      title: "选课状态查看"
    }
  },
  // 选课名单查看
  {
    path: "/xkmdck/jxapgl",
    name: "xkmdck",
    component: jxapgl,
    meta: {
      title: "教学安排管理"
    }
  },
  {
    path: "/xkmdck/xkxslb",
    name: "xkxslb",
    component: xkxslb,
    meta: {
      title: "选课学生列表"
    }
  },
  // 调课审核
  {
    path: "/tksh/index",
    name: "tksh",
    component: tksh,
    meta: {
      title: "调课审核"
    },
    redirect: "/tksh/unpass",
    children: [
      {
        path: "/tksh/pass",
        name: "tkshPass",
        component: tkshPass
      }
    ]
  },
  {
    path: "/tksh/unpass",
    name: "tkshUnpass",
    component: tkshUnpass,
    meta: {
      title: "调课审核"
    }
  },
  {
    path: "/tksh/tkshDetail/:route_params",
    name: "tkshDetail",
    component: tkshDetail,
    meta: {
      title: "调课审核"
    }
  },
  {
    path: "/tksh/plsh/:route_params",
    name: "tkshPlsh",
    component: tkshPlsh,
    meta: {
      title: "调课审核"
    }
  },
  {
    path: "/tksh/commompass/:route/:route_params",
    name: "tkshCommompass",
    component: tkshCommompass
  },
  // 北京劳动保障职业学院考试 安排查询
  {
    path: "/ksapcx/index",
    name: "ksapcxIndex",
    component: ksapcxIndex
  },
  {
    path: "/ksapcx/detail",
    name: "ksapcxDetail",
    component: ksapcxDetail
  },
  // 授课数据申请审核
  {
    path: "/sksjsqsh/index",
    name: "sksjsqshIndex",
    component: sksjsqshIndex
  },
  {
    path: "/sksjsqsh/detail",
    name: "sksjsqshDetail",
    component: sksjsqshDetail
  },
  // 数据确认审核
  {
    path: "/sksjqrsh/index",
    name: "sksjqrshIndex",
    component: sksjqrshIndex
  },
  {
    path: "/sksjqrsh/detail",
    name: "sksjqrshDetail",
    component: sksjqrshDetail
  },
  // 劳动任务审核
  {
    path: "/workTaskPass/index",
    name: "workTaskPassIndex",
    component: workTaskPassIndex
  },
  {
    path: "/workTaskPass/list",
    name: "workTaskPassList",
    component: workTaskPassList
  },
  // 免听审核
  {
    path: "/freePass/index",
    name: "freePassIndex",
    component: freePassIndex
  },
  {
    path: "/commom/HomeMore_10013",
    name: "HomeMore_10013",
    component: HomeMore_10013
  },
  {
    path: "/freePass/list",
    name: "freePassList",
    component: freePassList
  },
  {
    path: "/freePass/pass",
    name: "freePassPass",
    component: freePassPass
  },
  // 任务发布
  {
    path: "/taskAdd/index",
    name: "taskAddIndex",
    component: taskAddIndex
  },
  {
    path: "/taskAdd/item",
    name: "taskAddItem",
    component: taskAddItem
  },
  {
    path: "/taskAdd/studentDetail",
    name: "studentDetail",
    component: studentDetail
  },
  {
    path: "/taskAdd/evaluateItem",
    name: "evaluateItem",
    component: evaluateItem
  },
  {
    path: "/taskAdd/taskAdd",
    name: "taskAdd",
    component: taskAdd
  },
  // 实习考勤
  {
    path: "/practiceKQ/index",
    name: "practiceKQInedx",
    component: practiceKQInedx
  },
  {
    path: "/practiceKQ/item",
    name: "practiceKQItem",
    component: practiceKQItem
  },
  // 学生评价统计
  {
    path: "/evaluateSum/index",
    name: "evaluateSumIndex",
    component: evaluateSumIndex
  },
  //评价结果查看
  {
    path: "/evaluationResults/index",
    name: "evaluationResultsIndex",
    component: evaluationResultsIndex
  },
  {
    path: "/evaluateSum/index",
    name: "evaluateSumIndex",
    component: evaluateSumIndex
  },
  {
    path: "/evaluateSum/item",
    name: "evaluateSumItem",
    component: evaluateSumItem
  },
  // 教学咨询
  {
    path: "/jxzx/index",
    name: "jxzxIndex",
    component: jxzxIndex
  },
  {
    path: "/jxzx/item",
    name: "jxzxItem",
    component: jxzxItem
  },
  // 学生名单查询
  {
    path: "/studentInfo/index",
    name: "studentInfoIndex",
    component: studentInfoIndex
  },
  {
    path: "/studentInfo/info",
    name: "studentInfoInfo",
    component: studentInfoInfo
  },
  // 教室借用申请
  {
    path: "/brrow10008/index",
    name: "brrow10008Index",
    component: brrow10008Index
  },
  {
    path: "/brrow10008/apply",
    name: "brrow10008Apply",
    component: brrow10008Apply
  },
  // 学生信息查询
  {
    path: "/informationService/index",
    name: "informationService",
    component: informationService
    // meta: {
    //     keepAlive: true
    // }
  },
  // 学籍
  {
    path: "/informationService/studentStatus",
    name: "studentStatus",
    component: studentStatus
  },
  // 异动
  {
    path: "/informationService/change",
    name: "change",
    component: change
  },
  //成绩
  {
    path: "/informationService/achievement",
    name: "achievement",
    component: achievement
  },
  //信息查询的课表
  {
    path: "/informationService/informationInquiryTimetable",
    name: "informationInquiryTimetable",
    component: informationInquiryTimetable
  },
  //信息查询的创业创新学分
  {
    path: "/informationService/innovationCredits",
    name: "innovationCredits",
    component: innovationCredits
  },
  //
  {
    path: "/informationService/examination",
    name: "examination",
    component: examination
  },

  // 个人调课
  {
    path: "/personalTable/index",
    name: "personalTableIndex",
    component: personalTableIndex
  },
  {
    path: "/personalTable/apply",
    name: "personalTableApply",
    component: personalTableApply
  },
  // 课程测试
  {
    path: "/classTest/index",
    name: "classTest",
    component: classTest
  },
  // 调课申请
  {
    path: "/exchangeK/index",
    name: "exchangeK",
    component: exchangeK
  },
  {
    path: "/exchangeK/item",
    name: "exchangeKItem",
    component: exchangeKItem
  },
  // 调课申请记录
  {
    path: "/exchangeK/historList",
    name: "exchangeKHistoryList",
    component: exchangeKHistoryList
  },
  // 工作量查询
  {
    path: "/workNum/index",
    name: "workNum",
    component: workNum
  },
  {
    path: "/workNum/index_shzdx",
    name: "workNum_shzdx",
    component: workNum_shzdx
  },
  // 教室借用
  {
    path: "/roomBorrow",
    component: borrowBar,
    redirect: "/bindex",
    children: [
      {
        path: "/bindex",
        name: "roomBorrow",
        component: roomBorrow
      },
      {
        path: "/bList",
        name: "bList",
        component: borrowList
      }
    ]
  },
  {
    path: "/moreResearch",
    name: "moreResearch",
    component: moreResearch
  },
  // 教室借用记录
  {
    path: "/roomBorrow/historyList",
    name: "roomBorrowHistoryList",
    component: roomBorrowHistoryList
  },
  {
    path: "/historyList_10534",
    name: "historyList_10534",
    component: historyList_10534
  },
  // 成绩管理
  // 成绩修改
  {
    path: "/grade/update/index",
    name: "updateIndex",
    component: updateIndex
  },
  {
    path: "/grade/update",
    name: "gradeUpdate",
    component: gradeUpdate
  },
  // 成绩查询
  {
    path: "/grade/search/index",
    name: "searchIndex",
    component: searchIndex
  },
  {
    path: "/grade/search/index_13383",
    name: "searchIndex_13383",
    component: searchIndex_13383
  },
  {
    path: "/grade/search/search",
    name: "cjsearchIndex",
    component: cjsearchIndex
  },
  {
    path: "/grade/search/grade",
    name: "cjsearchGrade",
    component: cjsearchGrade
  },
  {
    path: "/grade/item",
    name: "gradeItem",
    component: gradeItem
  },
  // 培养方案
  {
    path: "/train/indpyfazgIndexex",
    name: "pyfazgIndex",
    component: pyfazgIndex
  },
  {
    path: "/train/commonIndex",
    name: "commonIndex",
    component: commonIndex
  },
  // 专业教学进程
  {
    path: "/train/teachingProcess",
    name: "teachingProcess",
    component: teachingProcess
  },
  // 教学计划
  {
    path: "/train/teachingPlan",
    name: "teachingPlan",
    component: teachingPlan
  },
  // 审核
  {
    path: "/pass/index",
    name: "pass",
    component: pass
  },
  {
    path: "pass/passBar",
    component: passBar,
    redirect: "/pass/passIndex",
    children: [
      {
        path: "/pass/passIndex",
        name: "passIndex",
        component: passIndex
      },
      {
        path: "/pass/passList",
        name: "passList",
        component: passList
      }
    ]
  },
  {
    path: "/pass/unDeal",
    name: "unDeal",
    component: unDeal
  },
  {
    path: "/pass/deal",
    name: "deal",
    component: deal
  },
  // 班级课表
  {
    path: "/classTable/index",
    name: "classTable",
    component: classTable
  },
  // 全校课表
  {
    path: "/classTable/indexqx",
    name: "indexqx",
    component: indexqx
  },
  // 课程成绩单
  {
    path: "/classTable/indexkccjd",
    name: "indexkccjd",
    component: indexkccjd
  },
  {
    path: "/teacher/changeCoures",
    name: "tea_changeCoures",
    component: () =>
      import("@/components/newPages/teacher/changeCoures/index.vue")
  },
  {
    path: "/teacher/changeCoures/detail",
    name: "tea_changeCouresDetail",
    component: () =>
      import("@/components/newPages/teacher/changeCoures/detail.vue")
  },
  {
    path: "/teacher/changeCoures/details",
    name: "tea_changeCouresDetail",
    component: () =>
      import("@/components/newPages/teacher/changeCoures/details.vue")
  },
  {
    path: "/teacher/changeCoures/reviewList",
    name: "tea_changeCouresReviewList",
    component: () =>
      import("@/components/newPages/teacher/changeCoures/reviewList.vue")
  },
  {
    path: "/teacher/changeCoures/reviewDetail",
    name: "tea_changeCouresReviewDetail",
    component: () =>
      import("@/components/newPages/teacher/changeCoures/reviewDetail.vue")
  },
  {
    path: "/teacher/changeCoures/reviewMoreDetail",
    name: "tea_changeCouresReviewMoreDetail",
    component: () =>
      import("@/components/newPages/teacher/changeCoures/reviewMoreDetail.vue")
  },
  {
    path: "/teacher/changeCoures/reviewForm",
    name: "tea_changeCouresReviewForm",
    component: () =>
      import("@/components/newPages/teacher/changeCoures/reviewForm.vue")
  },
  {
    path: "/teacher/semester_Score",
    name: "teacher_semester_Score",
    component: () =>
      import("@/components/teacher/Score/semester_Score.vue")
  },
  {
    path:'/ksxxcx/index',
    name:'ksxxcx',
    component:ksxxcx
  },
];
export default newTeacherRoute;



// WEBPACK FOOTER //
// ./src/router/newTeacher.js